<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default
{
    name: 'mv-subscriber-filter',

    props:
    {
        value: {
            type: Object,
            default: () => { return { relation: 'or', rules: [], }}
        },

    },

    methods:
    {
        addRule()
        {
            this.filter.rules.push({
                field: null,
                condition: '==',
                value: null,
            })
        },

        addGroup()
        {
            this.filter.rules.push({
                filter: {
                    relation: 'or',
                    rules: [],
                },
            })
        },

        removeRule(index)
        {
            this.filter.rules.splice(index, 1)
        }
    },

    computed:
    {
        ...mapGetters({
            artists: 'artistList',
            categories: 'artistCatgoriesList',
        }),
    },

    data()
    {
        return {
            fields: [
                {
                    id: 'wish_list_id',
                    name: this.$t('WISHLIST.WISHLIST')
                },

                {
                    id: 'artist_id',
                    name: this.$t('ARTIST.ARTIST')
                },

                {
                    id: 'category_id',
                    name: this.$t('ARTIST.CATEGORY')
                },
                {
                    id: 'purchase_done',
                    name: this.$t('WISHLIST.PURCHASE')
                },
                {
                    id: 'scancode',
                    name: this.$t('WISHLIST.SCANCODE')
                },

                {
                    id: 'referrer',
                    name: this.$t('WISHLIST.REFERRER')
                },

            ],

            conditions: [
                {
                    id: '==',
                    name: this.$t('GENERAL.EQUAL'),
                },

                {
                    id: '!=',
                    name: this.$t('GENERAL.NOT_EQUAL'),
                },

            ],

            booleans: [
                {
                    id: 0,
                    name: this.$t('GENERAL.NO'),
                },

                {
                    id: 1,
                    name: this.$t('GENERAL.YES'),
                },

            ],

            wishlists: [],
            filter: this.value,
        }
    },

    mounted()
    {
        this.$store.dispatch('artistCheck')
        this.$store.dispatch('artistCategoryCheck')
        axios.get(process.env.API_URL + '/v1/admin/wishlists').then(({data}) => {
            this.wishlists = data
        })
    }
}
</script>

<template>
<div>
    <div class="panel panel-primary">
        <div class="panel-heading">
            <div class="row">
                <div class="col-md-8">
                    <label>
                        {{ $t('GENERAL.RELATION')}}
                    </label>
                </div>
                <div class="col-md-4">
                    <select class="form-control" v-model="filter.relation">
                        <option value="or">{{ $t('GENERAL.OR') }}</option>
                        <option value="and">{{ $t('GENERAL.AND') }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="panel-body">

            <div class="row">
                <div class="col-xs-12 text-right">
                    <button class="btn btn-success btn-xs" @click="addRule">
                        <icon name="plus"></icon>
                    </button>
                    <button class="btn btn-primary btn-xs" @click="addGroup">
                        <icon name="code-fork"></icon>
                    </button>
                </div>
            </div>

            <div class="row" v-for="(rule, index) in filter.rules" :key="index">

                <template v-if="rule.filter">
                    <div class="col-sm-10">
                        <mv-subscriber-filter v-model="rule.filter"></mv-subscriber-filter>
                    </div>
                </template>

                <template v-else>

                    <div class="col-sm-4">
                        <label>{{ $t('GENERAL.FIELD') }}</label>
                        <select class="form-control" v-model="rule.field" @input="rule.value = null">
                            <option v-for="field in fields" :key="field.id" :value="field.id">{{ field.name }}</option>
                        </select>
                    </div>

                    <!--
                    <div class="col-sm-2">
                        <label>{{ $t('GENERAL.CONDITION') }}</label>
                        <select class="form-control" v-model="rule.condition" >
                            <option v-for="condition in conditions" :key="condition.id" :value="condition.id">{{ condition.name }}</option>
                        </select>
                    </div>
                    -->

                    <div class="col-sm-6">
                        <label>{{ $t('GENERAL.VALUE') }}</label>
                        <template v-if="rule.field == 'wish_list_id'">
                            <v-select :options="wishlists" label="name" v-model="rule.value">
        
                            </v-select>
                        </template>
                        <template v-else-if="rule.field == 'artist_id'">
                            <v-select :options="artists" label="name" v-model="rule.value">
                                <template slot="option" slot-scope="option">
                                    <div class="row option-row">
                                        <div class="col-sm-10">
                                            <div class="text">
                                                {{ option.name }} 
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </v-select>
                        </template>
                        <template v-else-if="rule.field == 'category_id'">
                            <v-select :options="categories" label="name" v-model="rule.value">
                                <template slot="option" slot-scope="option">
                                    <div class="row option-row">
                                        <div class="col-sm-10">
                                            <div class="text">
                                                {{ option.name }} 
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </v-select>
                        </template>
                        <template v-else>
                            <select class="form-control" v-model="rule.value">
                                <option v-for="b in booleans" :key="b.id" :value="b.id">{{ b.name }}</option>
                            </select>
                        </template>
                    </div>
                </template>


                <div class="col-sm-2 text-right">
                    <div>
                        <label>&nbsp;</label>
                        <div>
                            <button class="btn btn-warning btn-xs" @click="removeRule(index)">
                                <icon name="remove"></icon>
                            </button>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</div>
</template>



// WEBPACK FOOTER //
// src/components/SubscriberFilter.vue